export enum AutoExchange {
  LANDING_PAGE_INIT = '@@AutoExchange/init',

  FAILURE = 'RECURRING_EXCHANGE_FAILURE',
  VALIDATION_FAILURE = 'RECURRING_EXCHANGE_VALIDATION_FAILURE',
  UPDATE_FUND_INPUT = '@@AutoExchange/UPDATE_FUND_INPUT',
  UPDATE_TO_FUND_NOTE = '@@AutoExchange/UPDATE_TO_FUND_NOTE',
}
